import React from "react";

const Title = ({ title }) => {
  return (
    <>
      <div className="main-title">
        <h2>{title}</h2>
        <div className="heading-border"></div>
      </div>
    </>
  );
};

export default Title;
